import { Box, Typography } from '@mui/material';
import { Mail } from 'lucide-react';
import { MdErrorOutline } from 'react-icons/md';

interface ContactDeveloperProps {
  message: string;
}
const ContactDeveloper: React.FC<ContactDeveloperProps> = ({
  message, // Default message
}) => {
  const email = 'contact@cacxi.com';
  const subject = encodeURIComponent('Issue: Failed to Create Organisation');
  const mailtoLink = `mailto:${email}?subject=${subject}`;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh', // Make the box take up the full viewport height
        textAlign: 'center',
        mt: -8, // Adjust margin-top to potentially center vertically if needed
        p: 2,
      }}
    >
      {/* <ErrorOutlineIcon color="error" sx={{ fontSize: 60, mb: 1 }} /> */}
      <MdErrorOutline color="error" fontSize={60} />
      <Typography variant="h6" color="error" gutterBottom>
        {message}
      </Typography>
      <Typography variant="body1" gutterBottom>
        Something went wrong. Please contact our support team.
      </Typography>
      <Box
        component="a"
        href={mailtoLink}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          color: 'primary.main',
          textDecoration: 'none',
          cursor: 'pointer',
        }}
      >
        <Mail className="mr-2" />
        <Typography variant="h6">{email}</Typography>
      </Box>
    </Box>
  );
};

export default ContactDeveloper;
